import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import _ from 'lodash';

export interface Model {
  title: string;
  data: any;
}

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css', '../../myreports.component.css']
})
export class PieChartComponent extends DialogComponent<Model, any> implements OnInit {
  chartError = false;
  title: string;
  data: any;
  public pie_ChartData: any = {
      data: []
  };
  public pie_ChartOptions: any = {
    height:  $(window).height() * 0.79
  };

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.pie_ChartData = this.data.chartData;
    this.pie_ChartOptions = _.merge(this.data.options, this.pie_ChartOptions);
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/pie-chart/pie-chart.component.ts